// Keystroke filters for numeric inputs. They only block printable characters
// that can't be part of a number; editing and navigation keys (arrows, Delete,
// Home/End, Enter...) and shortcuts (copy, paste, select all, undo) always pass.
// Decimal precision is not capped here: a keydown handler can't see the caret
// on a type="number" input, so it would lock the field once the value had two
// decimals. The inputs' `step` attribute caps it at submit instead.
export const verifyNumberInput = (e: React.KeyboardEvent<HTMLElement>, isDecimal: boolean) => {
	const charCode = e.code;
	const charStr = e.key;
	const isNamedKey = charStr.length > 1;
	const isShortcut = e.ctrlKey || e.metaKey || e.altKey;
	if (!isNamedKey && !isShortcut && !charStr.match(/^[0-9]$/) && !(isDecimal && charStr === '.')) e.preventDefault();
	return { charCode, charStr };
};

export const allowsOnlyNumbers = (e: React.KeyboardEvent<HTMLElement>) => {
	verifyNumberInput(e, false);
};

export const allowsDecimals = (e: React.KeyboardEvent<HTMLElement>) => {
	verifyNumberInput(e, true);
};
